/**
 * @file Homepage Hero
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Hero component
 */
const vHpHero = () => {
	const hpHero = document.querySelector('.v-hp-hero');

	if (!hpHero) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	gsap.timeline({
		scrollTrigger: {
			trigger: 'body',
			start:   'top top',
			end:     '+=300px',
			scrub:   true,
			pin:     '.v-pin-top',
		},
		defaults: {
			ease: 'sine.in',
		},
	})
		.to('.v-hp-hero__content--dark', {
			'--clip': '0%',
		})
		.to('.v-header__logo', {
			scale: 1,
			y:     0,
		}, '<');
};

export default vHpHero;
